import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import styles from './NumberedList.module.scss'

const propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.object),
  itemKey: PropTypes.string.isRequired,
  render: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
}

const NumberedList = ({ className, items, itemKey, render }) => (
  <ol className={classnames(className, styles.list)}>
    {items.map(itemMapper(itemKey, render))}
  </ol>
)

const itemMapper = (itemKey, Component) => item => (
  <li className={styles.item} key={item[itemKey]}>
    <Component {...item} />
  </li>
)

NumberedList.propTypes = propTypes

export default NumberedList
